import React from 'react';

import { easasAlert } from 'components/fragments/easas-global-fragment/EasasGlobalAlerts';
import ProductTemplateTable from "../../dashboard/product-template-table/ProductTemplateTable";

type ProductTemplateProps = {
    safeName: string
    filter?: string
    dateFrom: Date
    dateTo: Date
    transposed:boolean
}

const ProductTemplatePreview = ({safeName, filter, dateFrom, dateTo, transposed}: ProductTemplateProps) => {

    const onFetchError = (er: string) => {
        easasAlert({ summary: "Error while fetching", detail: er, severity: "error" });
    }

    return <ProductTemplateTable safeName={safeName}
                              filter={filter}
                              showTitle={false}
                              onFetchError={onFetchError}
                              retry={false}
                              exactDateFrom={dateFrom}
                              exactDateTo={dateTo}
                              hideDates
                              transposed={transposed}
                              itemsPerPage={10}
                              useExternalFilterEndpoint
        />
};

export default ProductTemplatePreview;